import router from '../router'

router.beforeEach((to, from, next) => {
  const token = window.sessionStorage.getItem('token') || ''
  if (token) {
    next()
  } else {
    window.location.href = '/login.html'
  }
})
